
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion-finder",
      function () {
        return require("private-next-pages/fashion-finder.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashion-finder"])
      });
    }
  